import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "pig-type-picker-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pig-type-picker-wrapper relative h-full", { 'pig-type-picker-forced': _ctx.isForced }])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["flex rounded-md bg-gray-200 relative h-full px-4", { '!h-10': _ctx.slim, 'opacity-50 cursor-not-allowed': _ctx.isForced }]),
      disabled: _ctx.isForced,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isWeaners = !_ctx.isWeaners))
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle(`width: ${_ctx.isWeaners ? _ctx.pigTypePickerOptions.weanersWidth + 24 : _ctx.pigTypePickerOptions.slaughterPigsWidth + 24}px; left: ${
                    _ctx.isWeaners ? `calc(100% - ${_ctx.pigTypePickerOptions.weanersWidth + 28}px)` : '4px'
                }`),
        class: "absolute z-10 top-1 bottom-1 bg-primary-700 rounded-md transition-all duration-300"
      }, null, 4),
      _createElementVNode("div", {
        ref: "slaughters",
        class: _normalizeClass([{ 'text-white': !_ctx.isWeaners }, "relative z-20 my-auto mr-4 whitespace-nowrap transition-all duration-300"])
      }, _toDisplayString(_ctx.$t('views.pigTypePicker.slaughterPigs')), 3),
      _createElementVNode("div", {
        ref: "weaners",
        class: _normalizeClass([{ 'text-white': _ctx.isWeaners }, "relative z-20 my-auto ml-4 whitespace-nowrap transition-all duration-300"])
      }, _toDisplayString(_ctx.$t('views.pigTypePicker.weaners')), 3)
    ], 10, _hoisted_1),
    (_ctx.isForced)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('views.pigTypePicker.lockedTooltip')), 1))
      : _createCommentVNode("", true)
  ], 2))
}